module.exports = __webpack_public_path__ + "img/recruiting.545b1d8e.svg";